import { T } from '@tribeplatform/react-components/i18n'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { TabHeader } from '../../TabView/index.js'

export const FederatedSearchCard = () => {
  const guideURL =
    'https://developers.bettermode.com/docs/guide/apps/federated-search'

  return (
    <>
      <TabHeader
        title={
          <T
            defaultMessage="Federated Search"
            id="Admin.FederatedSearch.Title"
          />
        }
        subtitle={
          <T
            defaultMessage="Integrate external data sources with community content for enhanced search."
            id="Admin.FederatedSearch.Subtitle"
          />
        }
      />
      <div className="w-full flex px-8 py-5">
        <div className="max-w-3xl w-full flex flex-col gap-y-5">
          <p className="text-content-subdued text-sm leading-relaxed">
            <T
              defaultMessage="Enhance community search by integrating both community content and external data sources. Federated search allows members to find relevant information across platforms by connecting a federated search URL in the developer portal whenever needed."
              id="Admin.FederatedSearch.Description"
            />
          </p>

          <Card className="bg-surface-subdued">
            <Card.Content>
              <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <div className="flex items-center gap-x-4">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center">
                    <SvgIcon
                      name="search"
                      className="w-5 h-5 text-action-primary"
                    />
                  </div>
                  <div className="flex flex-col gap-y-1">
                    <h3 className="text-heading-xs font-medium text-content">
                      <T
                        defaultMessage="Connect external sources"
                        id="Admin.FederatedSearch.Card.Title"
                      />
                    </h3>
                    <p className="text-content-subdued text-sm">
                      <T
                        defaultMessage="Set up a federated search URL in the developer portal to start pulling results from external platforms."
                        id="Admin.FederatedSearch.Card.Description"
                      />
                    </p>
                  </div>
                </div>

                <Button
                  className="shrink-0 rounded-full"
                  variant="secondaryNeutral"
                  as="a"
                  href={guideURL}
                  target="_blank"
                  trailingIcon={<SvgIcon name="link-external" />}
                >
                  <T
                    defaultMessage="Find out how"
                    id="Admin.FederatedSearch.FindOutHow"
                  />
                </Button>
              </div>
            </Card.Content>
          </Card>

          <p className="text-content-subdued text-sm leading-relaxed">
            <T
              defaultMessage="Once configured, search results from external sources will appear alongside community content, giving your members a unified search experience."
              id="Admin.FederatedSearch.Footer"
            />
          </p>
        </div>
      </div>
    </>
  )
}
